module.exports = __webpack_public_path__ + "img/checkmark.c0e004d8.png";